/*
 * Copyright 2026 North Carolina State University
 */

import React from 'react';
import FormWorkspace from '../components/FormWorkspace';

const IpmDataEntry = () => (
  <FormWorkspace
    kind="entry"
    title="Data Entry"
    subtitle="Record scouting, treatments, quarantine and other pest-management activity."
    emptyText="There are no data-entry forms yet. Create your own, or start from the Quarantine, Scouting and Treatment forms and adjust them."
    starterLabel="Use starter forms"
  />
);

export default IpmDataEntry;
